import { useMemo } from "react";
import { useAppSelector, useAppDispatch } from "../../../utils/hooks";
import LoadingSkeletonImageDynamic from "../../../components/LoadingSkeletonImageDynamic";
import { MdCancel } from "react-icons/md";
import { addOrRemoveUserId } from "../../../store/Slices/CreateGroupSlice";
import { useContactList } from "../../../store/api/useContactList";

export default function GroupMembersList() {
  const CreateGroup = useAppSelector((state) => state.CreateGroup);
  const OnlineUserList = useAppSelector((state) => state.OnlineUserList);
  const userData = useAppSelector((state) => state.userData);
  const ChatListArray = useAppSelector((state) => state.chatList);
  const archiveList = useAppSelector((state) => state.archiveList);
  const dispatch = useAppDispatch();
  const { data: contactListUser } = useContactList();

  const members = useMemo(() => {
    return CreateGroup.user_id.map((userId) => {
      if (userId == userData.user_id) {
        return {
          user_id: userId,
          name: "You",
          user_name: userData.user_name,
          profile_pic: userData.profile_pic,
          isSelf: true,
        };
      }

      const contact = contactListUser?.data?.find((c) => c.user_id == userId);
      if (contact) {
        return {
          user_id: userId,
          name: contact.name,
          user_name: contact.user_name,
          profile_pic: contact.profile_pic,
          isSelf: false,
        };
      }

      const chats = [
        ...(ChatListArray.Chats ?? []),
        ...(archiveList.Chats ?? []),
      ];
      const peer = chats.find(
        (chat) =>
          chat.Records[0]?.chat_type === "private" &&
          chat.PeerUserData?.user_id == userId,
      )?.PeerUserData;

      return {
        user_id: userId,
        name: peer?.full_name || peer?.user_name || `#${userId}`,
        user_name: peer?.user_name || "",
        profile_pic: peer?.profile_pic || "",
        isSelf: false,
      };
    });
  }, [
    CreateGroup.user_id,
    userData,
    contactListUser?.data,
    ChatListArray.Chats,
    archiveList.Chats,
  ]);

  return (
    <div className="[&>*+*]:border-t [&>*+*]:border-black/[0.06] dark:[&>*+*]:border-white/[0.08]">
      {members.map((e) => (
        <div key={e.user_id} className="flex items-center gap-3 px-3 py-3">
          <div className="relative h-12 w-12 shrink-0">
            <LoadingSkeletonImageDynamic
              radius=""
              className="h-12 w-12 rounded-full object-cover"
              image_height="100%"
              image_url={e.profile_pic}
              image_width=""
            />
            {OnlineUserList.onlineUsers.find(
              (user) => user.user_id == e.user_id,
            ) && (
              <img
                className="absolute bottom-0 right-0 z-30 h-3.5 w-3.5"
                src="/Home/Online_Green_dot.png"
                alt=""
              />
            )}
          </div>
          <div className="min-w-0 flex-1">
            <div className="truncate text-[16px] font-semibold capitalize text-darkText">
              {e.name}
            </div>
            {e.user_name ? (
              <div className="mt-0.5 truncate text-[13px] text-lightText">
                {e.user_name}
              </div>
            ) : null}
          </div>
          {!e.isSelf && (
            <button
              type="button"
              aria-label="Remove"
              onClick={() => {
                dispatch(
                  addOrRemoveUserId({
                    user_id: e.user_id,
                  }),
                );
              }}
              className="shrink-0 text-themeColor"
            >
              <MdCancel className="h-5 w-5" />
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
